import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import {  Modal } from 'antd';
import FilterSelect from "components/Form/filterSelect";
import * as Yup from "yup";
import { Link } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import {
  customStyleSelect,
  formatDateHandler,
  formatDateHandler2,
  toTitleCase,
} from "utils/common";
import useUploadHook from "components/uploadHook";
import { getExpenseApi, postExpensesApi, getExpenseType, updateExpensesApi, statusChangeExpenseApi, exportExpenseApi } from "api/services/expense";
import { toast, Bounce } from "react-toastify";
import { format } from "date-fns";
import { Button } from "components/Button";
import { useSelector } from "react-redux";
import { leaveStatusOptions } from "utils/constants";
import EssFullWidthModal from "components/modelpopup/baseModal";
import { Steps } from "antd";
import { FaCheckCircle } from "react-icons/fa";
import { MdPending } from "react-icons/md";
import { MdOutlineError } from "react-icons/md";
import { FaTimesCircle } from "react-icons/fa";

import Attachments from "components/Attachments/attachmentListEdit";
import AttachmentThumb from "components/Attachments/attachmentThumbEdit";
import { useMediaQuery } from "react-responsive";
import DateInput from "components/Form/dateInput";


const ExpenseCreateModal = (props) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const expenseApprovalSchema = Yup.object().shape({
    approval_status: Yup.object().required("Status is required"),
    company_user: Yup.object().required("user is required"),
    reference_date: Yup.string().required("Reference date is required"),
    cost_center: Yup.object(),
    comment: Yup.string(),
  });

  const expenseSchema = Yup.object().shape({
    company_user: Yup.object().required("user is required"),
    claim_no: Yup.string().required("Claim number is required"),
    reference_date: Yup.string().required("Reference date is required"),
  });
  const [loading, setLoading] = useState(false);
  const [userOption, setUserOption] = useState([]);
  const [numberOfDays, setNumberOfDays] = useState(5);
  const [expenseBalance, setLeaveBalance] = useState(0);
  const [roleDelegationEnabled, setDelegationEnabled] = useState(false);
  const [roleDelegationOptions, setDelegationOptions] = useState([]);
  const [roleDelegationLoading, setDelegationLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [ totals, setTotals ] = useState({});

  const [selectedExpense, setSelectedExpense] = useState("")

  const [currentStatusStep, setCurrentStatusStep] = useState(0);
  const [statusSteps, setStatusSteps] = useState([]);
  const [expenseTypeOptions, setExpenseTypeOptions] = useState([]);
  const [costCenterOptions, setCostCenterOptions] = useState([]);

  // const statusOptions = [
  //   {label:"Approved", value: "approved"},
  //   {label:"Rejected", value: "rejected"}
  // ]
  const { uploadLoading, handleFile } = useUploadHook();
  const { userData, userDataLoading, costCenter, costCenterLoading } = useSelector((state) => state.common);
  const { user, userLoading } = useSelector((state) => state.user);
  // const {
  //   control,
  //   handleSubmit,
  //   formState: { errors },
  //   getValues,
  //   watch,
  //   setStatusValue,
  //   setError,
  //   reset,
  //   register,
  // } = useForm({
  //   resolver: yupResolver(expenseSchema),
  //   defaultValues: {
  //     company_user: userData.length === 1 ? userData[0] : {},
      
  //   },
  // });

  const {
    control: statusControl,
    handleSubmit: handleStatusSubmit,
    formState: { errors: statusError },
    setValue: setStatusValue,
    reset: statusReset,
    setError: setStatusError,
    trigger,
    watch: statusWatch,
    register
  } = useForm({
    resolver: yupResolver(expenseApprovalSchema),
    defaultValues: {},
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  

  const { fields, remove } = useFieldArray({
    control: statusControl, // control props comes from useForm (optional: if you are using FormProvider)
    name: "attachments", // unique name for your Field Array
  });

  const {
    fields: expenseField,
    append,
    prepend,
    remove:expenseRemove,
    swap,
    move,
    insert,
   
  } = useFieldArray({
    control: statusControl, // control props comes from useForm (optional: if you are using FormProvider)
    name: "expense_claim_detail", // unique name for your Field Array
  });

  const createApprovalSteps = () => {
    let generated_steps = [];
    let current_step = selectedExpense?.approval_level;
    let existing_steps = selectedExpense?.expense_approval;

    if (selectedExpense?.approval_status == "cancelled") {
      generated_steps.push({
        title: "Request",
        subTitle: "Cancelled",
        description: <span className="text-wrap lh-1 text-dark" style={{fontSize:9}}>{`${formatDateHandler2(
          selectedExpense?.created_at
        )} by ${selectedExpense?.company_user?.first_name} ${
          selectedExpense?.company_user?.last_name
        }`}</span>,
        icon: <FaTimesCircle color="red" size={35} />,
      });
    } else {
      generated_steps.push({
        title: "Request",
        subTitle: "Created",
        description: <span className="text-wrap lh-1 text-dark" style={{fontSize:9}}>{`${formatDateHandler2(
          selectedExpense?.created_at
        )}  by ${selectedExpense?.company_user?.first_name} ${
          selectedExpense?.company_user?.last_name
        }`}</span>,
        icon: <FaCheckCircle color="green" size={35} />,
      });
    }
    existing_steps.forEach((item) => {
      generated_steps.push({
        title: "Approval",
        subTitle: toTitleCase(item?.status),
        description: <span className="text-wrap lh-1 text-dark" style={{fontSize:9}}>{`${
          item?.status == "pending"
            ? item.approver?.first_name + " " + item.approver?.last_name
            : toTitleCase(item.status) +
              " on " +
              formatDateHandler2(item?.approved_on) +
              " by " +
              item.approver?.first_name +
              " " +
              item.approver?.last_name
        } ${item?.comment ? "| Comment: " + item?.comment : ''}`}</span>,
        icon:
          item?.status == "pending" ? (
            <MdPending size={35} />
          ) : item?.status == "rejected" ? (
            <FaTimesCircle color="red" size={35} />
          ) : (
            <FaCheckCircle color="green" size={35} />
          ),
      });
    });
    setCurrentStatusStep(current_step);
    setStatusSteps(generated_steps);
 
  };

  useEffect(() => {
    if (selectedExpense) {
      console.log(user, selectedExpense.company_user, "UUUUU");
      if (
        user.id == selectedExpense.company_user?.id &&
        selectedExpense?.approval_status == "pending"
      ) {
        setStatusOptions(
          leaveStatusOptions.filter((item) => item.value == "cancelled")
        );
      }

      else if (
        user.id == selectedExpense.current_approver?.id &&
        selectedExpense?.approval_status == "pending"
      ) {
        setStatusOptions(
          leaveStatusOptions.filter((item) => item.value != "cancelled")
        );
      }
      else{
        setStatusOptions([]);
      }
      createApprovalSteps();





    } else {
      setStatusOptions([]);
    }
  }, [selectedExpense]);


  useEffect(()=>{
    if(props.expenseData){
        getExpenseApi(props.expenseData?.id).then(response=>{
            console.log(response.data, "LLLL")
            setSelectedExpense(response?.data)
        })
    }


  },[props.expenseData])

  useEffect(()=>{
    if(!expenseTypeOptions.length){
        getExpenseType().then(res=>{
            console.log(res.data)
    
            let expense_options = [...res.data.results].map(item=>{
                return{
                    label: item.name,
                    value: item.id
                }
            })
            setExpenseTypeOptions(expense_options)
        })
    }

  },[])
  
  useEffect(() => {
    if (costCenter) {
      setCostCenterOptions(costCenter.map(item => ({
        label: item.name,
        value: item.id
      })));
    }
  }, [costCenter]);

  useEffect(() => {
    if (selectedExpense?.id && userOption.length && expenseTypeOptions.length && props.expenseModal) {
      console.log(selectedExpense, "HHHHH");
      let user = userOption.find(item=> item.value == selectedExpense?.company_user?.id)
      setStatusValue("company_user", user || "");
      // setStatusValue("claim_no", selectedExpense?.claim_no || "");
      setStatusValue("reference_date", selectedExpense?.reference_date || "");
      
      // Set cost center value
      if (selectedExpense?.cost_center) {
        let costCenter = costCenterOptions.find(item => item.value == selectedExpense?.cost_center?.id);
        setStatusValue("cost_center", costCenter || "");
      }

      let claim_detail = selectedExpense?.expense_claim_detail.map(item=>{
        let expense_type_selected = expenseTypeOptions.find(ex_item=> ex_item.value == item.expense_type?.id )
        return {
            ...item,
            expense_type: expenseTypeOptions.find(ex_item=> ex_item.value == item.expense_type?.id ),
            attachments: item?.attachments?.map(item=> {
                return {
                  // id: item.id,
                  item_id:item.id,
                  url: item.url
                }
              })
        }
      })
      setStatusValue("expense_claim_detail", claim_detail||[]);
      setStatusValue("attachments", selectedExpense?.attachments?.map(item=> {
        return {
          // id: item.id,
          item_id:item.id,
          url: item.url
        }
      }))
      // let approvalStatus = leaveStatusOptions.find(item=> item.value == selectedExpense.approval_status)
      // console.log(approvalStatus, leaveStatusOptions,selectedExpense.approval_status, "JJJJ")
      // setStatusValue("approval_status", approvalStatus)
    } else {

      statusReset();
    }
  }, [selectedExpense,userOption, expenseTypeOptions, costCenterOptions, props.expenseModal ]);

  useEffect(() => {
    let access_scope = "all"; //props.user.role.access_scope;
    if (userData && props.user) {
      let users = [];

      if (access_scope === "all" || access_scope === "hierarchy") {
        users = userData.map((item) => ({
          label: `${item.first_name} ${item.last_name}`,
          value: item.id,
        }));
      } else if (access_scope === "self") {
        users = userData
          .filter((item) => item.id === props.user.id) // Restrict to logged-in user
          .map((item) => ({
            label: `${item.first_name} ${item.last_name}`,
            value: item.id,
          }));
      }

      setUserOption(users);
    }

    // if(userData){
    //   let users = userData.map(item=> {
    //     return{
    //         label: `${item.first_name} ${item.last_name}`,
    //         value: item.id
    //     }
    // })
    //   setUserOption(users)
    // }
  }, [userData]);

  useEffect(() => {
    if (userOption.length) {
      if (userOption.length === 1) {
        console.log("&&&&&&&&&&&&&&&&&", userOption[0]);
        setStatusValue("company_user", userOption[0]);
      }
    }
  }, [userOption, selectedExpense, props.expenseModal]);
  const fileUploadHandler = async (e) => {
    console.log(e.target.files, "EEEE");
    let attachments = [];
    const urls = await handleFile(e);
    if (Array.isArray(urls)) {
      attachments = urls.map((item) => {
        return { url: item };
      });
    } else {
      attachments.push({
        url: urls,
      });
    }
    console.log(fields, "LLLL");

    setStatusValue("attachments", [...fields, ...attachments]);
  };

  const detailFileUploadHandler = async (e, index) => {
    console.log(e.target.files, "EEEE");
    let attachments = [];
    const urls = await handleFile(e);
    if (Array.isArray(urls)) {
      attachments = urls.map((item) => {
        return { url: item };
      });
    } else {
      attachments.push({
        url: urls,
      });
    }

    console.log( expenseField[index].attachments,attachments, "DDDDDDD");


    
    setStatusValue(`expense_claim_detail.${index}.attachments`, [...expenseField[index].attachments,...attachments]);
    trigger(`expense_claim_detail.${index}.attachments`); // Ensure re-render

    // console.log(fields, "LLLL");

    // setStatusValue("attachments", [...fields, ...attachments]);
  };

  
  const expenses = statusWatch("expense_claim_detail")||[];

  const onStatusChange = (data) => {
    setLoading(true);

   
    data["approval_status"] = data?.approval_status?.value;

  data["company_user"] = data?.company_user?.value;
  data["cost_center"] = data?.cost_center?.value;
  if (data.reference_date) {
      data["reference_date"] = format(new Date(data.reference_date), "yyyy-MM-dd");
    }


    let details = data.expense_claim_detail?.map(item=> {

      return{
          ...item,
          posting_date: item?.posting_date? format(new Date(item.posting_date), "yyyy-MM-dd") : "",
          expense_type: item?.expense_type?.value || "",

          attachments: item?.attachments.map(item=>{
              return{
                id: item.item_id||"",
                url: item.url
              }
            })
      }
  })
    let attachments_data = data['attachments'].map(item=>{
      return{
        id: item.item_id||"",
        url: item.url
      }
    })
    data['attachments'] = attachments_data

  data.expense_claim_detail = details


  
    updateExpensesApi(selectedExpense?.id, data, )
      .then((response) => {
        setLoading(false);

        toast.success("Expense status updated!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        props.setExpenseModal(false);
        props.setExpenseData("");

        props.fetchExpenseList();

        console.log(response, "REEEEEE");
      })
      .catch((e) => {
        console.log(e, "eee");
        try {
          console.log(e.response.data, "EEEEE");
          // let response = e.response?.data?.error || "Error updating expense status!"
          setLoading(false);
          // toast.error(response, {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          //   closeOnClick: false,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "light",
          //   transition: Bounce,
          //   });

          if (e.response.data) {
            Object.entries(e.response.data).forEach(([k, v]) => {
              console.log(typeof v, k, "EEEEE");
              setStatusError(k, {
                type: "manual",
                message: v.join(", "),
              });
            });
          }
        } catch (err) {
          console.log(err, "LLLLLLL");
          let response =
            e.response?.data?.error || "Error updating expense status!";
          setLoading(false);
          toast.error(response, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        }
      });
  };




  const removeAttachment = (expenseIndex, indexToRemove) => {
    console.log(expenseIndex, indexToRemove, "KKKK")

    let attachments = expenses[expenseIndex].attachments
    attachments = attachments.filter((_, index) => index !== indexToRemove);
    console.log(attachments, "KKKKKKK")

    setStatusValue(`expense_claim_detail.${expenseIndex}.attachments`, attachments);
    trigger(`expense_claim_detail.${expenseIndex}.attachments`); // Ensure re-render

  }


  const changeTotal = () => {
    console.log(expenses, "KKKKKKK")
    let totals = expenses?.reduce(
        (totals, item) => {
          totals.expense_amount += Number(item.expense_amount) || 0;
          totals.expense_approved_amount += Number(item.expense_approved_amount) || 0;
          return totals;
        },
        { expense_amount: 0, expense_approved_amount: 0 }
      ); 
      setTotals(totals)

  }

      // ✅ useMemo for efficient total calculation
      useEffect(() => {
        console.log("HEREEEEE")
        if(props.expenseModal){
          return changeTotal()
        }
        
      }, [expenses, props.expenseModal]); // Recalculates only when `expenses` change
  
 

        // ✅ Update total onBlur instead of on every keystroke
  const handleBlur = () => {
    console.log("JJJJJ")
    return changeTotal()
  };

  // Add the export handler
  const handleExport = async () => {
    if (!selectedExpense?.id || !selectedExpense?.company_user?.id) return;
    setLoading(true);
    try {
      const response = await exportExpenseApi(selectedExpense.id, selectedExpense.company_user.id);

      // Get filename from Content-Disposition header
      let filename = "export.pdf";
      const disposition = response.headers["content-disposition"];
      if (disposition && disposition.indexOf("filename=") !== -1) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, "")
          .trim();
        if (!filename.toLowerCase().endsWith('.pdf')) {
          filename = 'export.pdf';
        }
      }

      // Create a blob and trigger download
      const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Failed to export expense!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <EssFullWidthModal
        mask={false}
        title={selectedExpense ? "Change expense status" : "Create Expense"}
        // style={{ top: 100 }}
        open={props.expenseModal}
        width={"40%"}
        footer={[]}
        onCancel={() => {
          console.log("CLOSEEEEEEEEEEEE STATUSSSSSS")

          statusReset();
          setDelegationEnabled(false);

          props?.setExpenseData("");
          props.setExpenseModal(false);
        }}
        className="full-width-modal"
      >
        {/* Export Button at the top */}
        {selectedExpense?.id && (
          <div className="d-flex justify-content-end mb-3">
            <Button
              className="btn btn-primary position-absolute "
              style={{top: "12px", right: "60px"}}
              loading={loading}
              type="button"
              label="Export"
              onClick={handleExport}
              disabled={loading}
            />
          </div>
        )}

        <div className="modal-content">
          <div className="modal-body">
            {/* {selectedExpense?.id ? ( */}
              <form onSubmit={handleStatusSubmit(onStatusChange)}>
                

              <div className="row" >
                  
                  <div className="col-md-12 col-sm-12" >
                    <div className="card p-3" >
                    <label className="col-form-label">
                      Approval status
                    </label>

                    <Steps
                    current={currentStatusStep}
                    // percent={60}
                    items={statusSteps}
                  />
                    </div>
                 
                  </div>
                </div>


              <div className="row">
                  <div className="input-block mb-3 col-md-6 col-sm-12">
                    <label className="col-form-label">
                      User <span className="text-danger">*</span>
                    </label>

                    <Controller
                      name={`company_user`}
                      // name={"assignee"}
                      control={statusControl}
                      // defaultValue=""
                      // rules={{ required: 'Select a contact' }}
                      render={({ field }) => (
                        <>
                          <FilterSelect
                          
                            // className={"w-50"}
                            isDisabled={true}
                            isClearable={true}
                            onChange={(e) => {
                              field.onChange(e);
                            }}
                            optionLabel={"label"}
                            optionValue={"value"}
                            options={userOption}
                            defaultValue={userOption[0]}
                            value={field.value}
                            placeholder={"Select user"}
                            styles={customStyleSelect}
                            isLoading={userDataLoading}
                          />
                        </>
                      )}
                    />
                 
                  </div>
                  <div className="input-block mb-3 col-md-6 col-sm-12">
                    <label className="col-form-label">
                    Reference date <span className="text-danger">*</span>
                    </label>
                    <div className="cal-icon">
                      <Controller
                        name="reference_date"
                        control={statusControl}
                        // rules={{ required: 'File name is required' }}
                        render={({ field }) => (
                          <DateInput
                          disabled={true}
                            className="form-control floating datetimepicker "
                            selected={field?.value}
                            onChange={(date) => {
                              
                              field.onChange(date);
                          
                            }}
                            dateFormat="dd-MM-yyyy"
                            // minDate={new Date()}
                          />
                        )}
                      />

                     
                    </div>
                  </div>
                </div>
               
                <div className="row">
                  <div className="input-block mb-3 col-md-6 col-sm-12">
                    <label className="col-form-label">
                      Cost Center <span className="text-danger">*</span>
                    </label>

                    <Controller
                      name={`cost_center`}
                      control={statusControl}
                      render={({ field }) => (
                        <>
                          <FilterSelect
                            isDisabled={true}
                            isClearable={true}
                            onChange={(e) => {
                              field.onChange(e);
                            }}
                            optionLabel={"label"}
                            optionValue={"value"}
                            options={costCenterOptions}
                            value={field.value}
                            placeholder={"Select cost center"}
                            styles={customStyleSelect}
                            isLoading={costCenterLoading}
                          />
                        </>
                      )}
                    />
                    {statusError.cost_center && (
                      <small className="text-danger">
                        {statusError.cost_center?.message}
                      </small>
                    )}
                  </div>
                </div>

                <div className="row">
        
                  {/* <div className="input-block mb-3 col-md-6 col-sm-12">
                    <label className="col-form-label">
                    Posting date <span className="text-danger">*</span>
                    </label>
                    <div className="cal-icon">
                      <Controller
                        name="posting_date"
                        control={statusControl}
                        // rules={{ required: 'File name is required' }}
                        render={({ field }) => (
                          <DatePicker
                          disabled={true}
                            className="form-control floating datetimepicker "
                            selected={field?.value}
                            onChange={(date) => {
                              
                              field.onChange(date);
                          
                            }}
                            dateFormat="dd-MM-yyyy"
                            // minDate={new Date()}
                          />
                        )}
                      />

                      {errors.posting_date && (
                        <small className="text-danger">
                          {errors.posting_date?.message}
                        </small>
                      )}
                    </div>
                  </div> */}
               

                </div>

                {/* <div className="row" >
                <div className="input-block mb-3 col-md-6 col-sm-12">
                    <label className="col-form-label">
                    Description <span className="text-danger">*</span>
                    </label>
                    
                    <Controller
                      name="description"
                      control={statusControl}
                      // rules={{ required: 'File name is required' }}
                      render={({ field }) => (
                        <textarea
                        disabled={true}
                          rows={4}
                          className="form-control"
                          value={field?.value}
                          onChange={field?.onChange}
                        />
                      )}
                    />
                  
                    
                  </div>
                   </div>
                 */}
             

{
  isMobile ? 
  <div className="row expense-modal-table-mobile">
  <div className="col-md-12 col-sm-12">
  {/* <Link
to="#"
className=" btn btn-success mb-2"
title="Add"
id="addProduct"
onClick={() => {
  append({
    expense_type: "",
    expense_amount: "",
    posting_date: "",
    description: "",
    expense_approved_amount: "",
    attachments: [],
  });
}}
>
<i className="fa-solid fa-plus" />
</Link> */}

{
expenseField.map((row, expenseIndex) => (
<div  key={row.id} className="card p-3">
  <div className="row">
    {/* Type */}
    <div className="col-6 mb-3">
      <label className="form-label">Type</label>
      <Controller
    name={`expense_claim_detail.${expenseIndex}.expense_type`}
    // name={"assignee"}
    control={statusControl}
    // defaultValue=""
    // rules={{ required: 'Select a contact' }}
    render={({ field }) => (
      <>
        <FilterSelect
          isDisabled={true}
          // isClearable={true}
          onChange={(e) => {
            field.onChange(e);
          }}
          optionLabel={"label"}
          optionValue={"value"}
          options={expenseTypeOptions}
          value={field.value}
          placeholder={"Charge type"}
          styles={customStyleSelect}
          isLoading={false}
          menuPlacement="top"
        />
      </>
    )}
  />
    
    </div>

    {/* Date */}
    <div className="col-6 mb-3">
      <label className="form-label">Date</label>
      <Controller
                                  name={`expense_claim_detail.${expenseIndex}.posting_date`}
                                  control={statusControl}
                                  // rules={{ required: 'File name is required' }}
                                  render={({ field }) => (
                                    <DateInput
                                    disabled={true}
                                      className="form-control  "
                                      selected={field?.value}
                                      onChange={(date) => {
                                        field.onChange(date);
                                      }}
                                      dateFormat="dd-MM-yyyy"
                                      // minDate={new Date()}
                                    />
                                  )}
                                />
      {/* <input
        disabled={true}
        // value={row.posting_date}
          {...register(`expense_claim_detail.${expenseIndex}.posting_date`)}
          type="date"
          className="form-control"
          /> */}
    </div>
  </div>

  <div className="row">
    {/* Description */}
    <div className="col-6 mb-3">
      <label className="form-label">Description</label>
      <textarea
        disabled={true}
        // value={row.description}
              {...register(`expense_claim_detail.${expenseIndex}.description`)}
              className="form-control"
              rows={1}
              placeholder="Description"
              />
    </div>

    {/* Amount */}
    <div className="col-6  mb-3">
      <label className="form-label">Amount</label>
      <input
        disabled={true}
        value={row.expense_amount}
              {...register(`expense_claim_detail.${expenseIndex}.expense_amount`)}
              type="number"
              className="form-control"
              placeholder="Amount"
              />
    </div>
  </div>

  <div className="row">
    {/* Approved Amount */}
    <div className="col-6  mb-3">
      <label className="form-label">Approved Amount</label>
      <input
        disabled={statusOptions.filter(item=> item.value!=="cancelled").length == 0}
        max={row?.expense_amount}
        // value={row.expense_approved_amount}
              {...register(`expense_claim_detail.${expenseIndex}.expense_approved_amount`)}
              type="number"
              className="form-control"
              placeholder="Approved Amount"
              onBlur={handleBlur}
             step="0.01"
              />
    </div>

    {/* Attachments */}
    <div className="col-6  mb-3">
    <label className="form-label">Attachments</label>
    <div className="input-group">
        <input
        
        multiple
              type="file"
              {...register(`expense_claim_detail.${expenseIndex}.attachments`)}
              className="form-control"
              onChange={(e)=>detailFileUploadHandler(e,expenseIndex )}
              disabled={true}
      id="fileInput" 

              />
              
              {uploadLoading ?
              <label className="input-group-text" htmlFor="fileInput">
               <i className="fas fa-spinner fa-spin" ></i> 
               </label>
               : ""}
              
          </div>
    </div>

    <div className="col-12 mb-3" >
    <AttachmentThumb 
              fields={expenses&&expenses[expenseIndex]?.attachments}
              remove={(itemIndex)=>{}}
               />
    </div>
  </div>
  {/* <Link
    className="text-danger font-18 remove"
    title="Remove"
    onClick={() => expenseRemove(expenseIndex)}
  >
    <i className="fa-regular fa-trash-can" />
  </Link> */}
</div>
))}


  </div>
</div>
:
<div className="row">
<div className="col-md-12 col-sm-12">
  <div  className="table-responsive expense-modal-table-desktop">
    <table
    
      className="table table-hover table-white expense-detail-table"
      id="addTable"
    >
      <thead>
        <tr>
          <th style={{width: '5%'}}>#</th>
          <th style={{width: '12%'}}>Type</th>
          <th style={{width: '12%'}}>Date</th>
          <th style={{width: '35%'}}>Description</th>
          <th style={{width: '10%'}}>Amount</th>
          <th style={{width: '10%'}}>Approved Amount</th>
          <th style={{width: '15%'}}>Attachments</th>
          
          <th style={{width: '5%'}}> </th>
        </tr>
      </thead>
      <tbody className="expense-detail-table-body">
        <tr>
{/*                        
          <td>
            <Link
              to="#"
              className="text-success font-18"
              title="Add"
              id="addProduct"
              onClick={()=> {
                  append({
                      expense_type: "",
                      expense_amount: "",
                      posting_date: "",
                      description: "",
                      attachments: [],
                    })
                  
              }}
            >
              <i className="fa-solid fa-plus" />
            </Link>
          </td> */}
        </tr>
        {expenseField.map((row, expenseIndex) => (
          <>
          <tr key={row.id}>
            <td>{expenseIndex+1}</td>
            <td>
            <Controller
        name={`expense_claim_detail.${expenseIndex}.expense_type`}
        // name={"assignee"}
        control={statusControl}
        // defaultValue=""
        // rules={{ required: 'Select a contact' }}
        render={({ field }) => (
          <>
            <FilterSelect
              isDisabled={true}
              // isClearable={true}
              onChange={(e) => {
                field.onChange(e);
              }}
              optionLabel={"label"}
              optionValue={"value"}
              options={expenseTypeOptions}
              value={field.value}
              placeholder={"Charge type"}
              styles={customStyleSelect}
              isLoading={false}
              menuPlacement="top"
            />
          </>
        )}
      />
          

           
            </td>
            <td>
            <Controller
                                  name={`expense_claim_detail.${expenseIndex}.posting_date`}
                                  control={statusControl}
                                  // rules={{ required: 'File name is required' }}
                                  render={({ field }) => (
                                    <DateInput
                                    disabled={true}
                                      className="form-control  "
                                      selected={field?.value}
                                      onChange={(date) => {
                                        field.onChange(date);
                                      }}
                                      dateFormat="dd-MM-yyyy"
                                      // minDate={new Date()}
                                    />
                                  )}
                                />
            {/* <input
            disabled={true}
            // value={row.posting_date}
              {...register(`expense_claim_detail.${expenseIndex}.posting_date`)}
              type="date"
              className="form-control"
              /> */}
            </td>
            <td>
            <textarea
            disabled={true}
            // value={row.description}
                  {...register(`expense_claim_detail.${expenseIndex}.description`)}
                  className="form-control"
                  rows={2}
                  placeholder="Description"
                  />
            </td>
            <td>
            <input
            disabled={true}
            value={row.expense_amount}
                  {...register(`expense_claim_detail.${expenseIndex}.expense_amount`)}
                  type="number"
                  className="form-control"
                  placeholder="Amount"
                  />
            </td>
            <td>
            <input
            disabled={statusOptions.filter(item=> item.value!=="cancelled").length == 0}
            max={row?.expense_amount}
            // value={row.expense_approved_amount}
                  {...register(`expense_claim_detail.${expenseIndex}.expense_approved_amount`)}
                  type="number"
                  className="form-control"
                  placeholder="Approved Amount"
                  onBlur={handleBlur}
                 step="0.01"
                  />
            </td>
           
            <td>
            <div className="input-group">
            <input
            
            multiple
                  type="file"
                  {...register(`expense_claim_detail.${expenseIndex}.attachments`)}
                  className="form-control"
                  onChange={(e)=>detailFileUploadHandler(e,expenseIndex )}
                  disabled={true}
          id="fileInput" 

                  />
                  
                  {uploadLoading ?
                  <label className="input-group-text" htmlFor="fileInput">
                   <i className="fas fa-spinner fa-spin" ></i> 
                   </label>
                   : ""}
                  
              </div>
              
              
            </td>
           
            <td>
              <Link
                className="text-danger font-18 remove"
                title="Remove"
              //   disabled={true}
              //   onClick={() => expenseRemove(expenseIndex)}
              >
                <i className="fa-regular fa-trash-can" />
              </Link>
            </td>
            
          </tr>
          <tr>
              <td colSpan={6} >
              <AttachmentThumb 
              fields={expenses&&expenses[expenseIndex]?.attachments}
              remove={(itemIndex)=>{}}
               />
              </td>
         
               </tr>
          </>
          
        ))}
      </tbody>
    </table>

  </div>
 
</div>
{/*
 */}
</div>

}
            
    {/* ✅ Total Section at Bottom */}
    <div className="  bg-light p-3 border-top d-flex align-items-end justify-content-end">
      <div className="  " ><h5 className="fw-bold">Total Expense:</h5></div>
      <div className=" col-md-1  d-flex justify-content-end" ><h5 className="fw-bold"> {totals?.expense_amount ? parseFloat(totals?.expense_amount).toFixed(2) : 0}</h5></div>
      
    </div>
    <div className="  bg-light p-3 border-top d-flex align-items-end justify-content-end">
      <div className=" " ><h5 className="fw-bold">Approved:</h5></div>
      <div className=" col-md-1 d-flex justify-content-end" ><h5 className="fw-bold"> {totals?.expense_approved_amount ? totals?.expense_approved_amount.toFixed(2) : 0}</h5></div>
      
    </div>


               




            <div className="row" >
                <div className="input-block mb-3  col-md-6 col-sm-12">
                    <label className="col-form-label mt-4">Attachments</label>
                    <Attachments
                      fields={selectedExpense?.attachments}
                      remove={()=>{}}
                    />
                  </div>
                </div>
          

                <div className="row">
                  <div className="input-block mb-3 col-md-6 col-sm-12">
                    <label className="col-form-label">
                      Change Status <span className="text-danger">*</span>
                    </label>
                    
                    {/* Replace dropdown with radio buttons for Approve/Reject */}
                    <div className="status-radio-group">
                      {statusOptions.length > 0 ? (
                        <>
                        <div className="form-check form-check-inline" key={"approve"}>
                            <input
                            style={{cursor: "pointer", width: "20px", height: "20px"}}
                              className={`form-check-input me-2 ${statusWatch("approval_status")?.value === "approved" ? "bg-success border-success" : ""}`}
                              type="checkbox"
                              id={`status-approve`}
                              disabled={statusOptions.length === 0}
                              checked={statusWatch("approval_status")?.value === "approved"}
                              onChange={() => {
                                setStatusValue("approval_status", statusOptions.find(opt => opt.value === "approved"));
                              }}
                            />
                            <label className="form-check-label" htmlFor={`status-approve`}>
                              Approve
                            </label>
                          </div>

                          <div className="form-check form-check-inline" key={"reject "}>
                            <input
                            style={{cursor: "pointer", width: "20px", height: "20px"}}
                              className={`form-check-input me-2 ${statusWatch("approval_status")?.value === "rejected" ? "bg-danger border-danger " : ""}`}
                              type="checkbox"
                              id={`status-reject`}
                              disabled={statusOptions.length === 0}
                              checked={statusWatch("approval_status")?.value === "rejected"}
                              onChange={() => {
                                setStatusValue("approval_status", statusOptions.find(opt => opt.value === "rejected"));
                              }}
                            />
                            <label className="form-check-label" htmlFor={`status-reject`}>
                              Reject
                            </label>
                          </div>
                        </>
                      ) : (
                        <div className="text-muted">No status change options available</div>
                      )}
                      
                      {/* Show cancel option separately if available */}
                      {statusOptions.some(option => option.value === "cancelled") && (
                        <div className="form-check mt-2">
                          <input
                            style={{cursor: "pointer", width: "20px", height: "20px"}}
                            className={`form-check-input me-2 ${statusWatch("approval_status")?.value === "cancelled" ? "bg-danger border-danger" : ""}`}
                            type="checkbox"
                            id="status-cancelled"
                            checked={statusWatch("approval_status")?.value === "cancelled"}
                            onChange={() => {
                              if(statusWatch("approval_status")?.value === "cancelled"){
                                setStatusValue("approval_status", { label: "", value: "" });
                              }else{
                                setStatusValue("approval_status", statusOptions.find(opt => opt.value === "cancelled"));
                              }
                            }}
                          />
                          <label className="form-check-label" htmlFor="status-cancelled">
                            Cancel Request
                          </label>
                        </div>
                      )}
                    </div>
                    
                    {statusError.approval_status && (
                      <small className="text-danger">
                        {statusError.approval_status?.message}
                      </small>
                    )}
                    <br />
                  </div>
               
                </div>

                {/* Comment Section */}
                <div className="row">
                  <div className="input-block mb-3 col-md-12 col-sm-12">
                    <label className="col-form-label">
                      Comment
                    </label>
                    <Controller
                      name="comment"
                      control={statusControl}
                      render={({ field }) => (
                        <textarea
                          rows={4}
                          className="form-control"
                          placeholder="Enter your comment..."
                          value={field?.value || ""}
                          onChange={field?.onChange}
                        />
                      )}
                    />
                    {statusError.comment && (
                      <small className="text-danger">
                        {statusError.comment?.message}
                      </small>
                    )}
                  </div>
                </div>

                <div className="row"></div>

                <div className="submit-section">
                  <Button
                    loading={loading}
                    disabled={loading || uploadLoading}
                    className="btn btn-primary submit-btn"
                    type="submit"
                    label="Submit"
                  />
                </div>
              </form>
            
          </div>
        </div>
      </EssFullWidthModal>
    </>
  );
};

export default ExpenseCreateModal;
